import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  SUBCONTRACT_COST_GET_REQUEST,
  SUBCONTRACT_COST_GET_SUCCESS,
  SUBCONTRACT_COST_GET_FAILURE,
  SUBCONTRACT_COST_GET_RESET,
  SUBCONTRACT_COST_CREATE_REQUEST,
  SUBCONTRACT_COST_CREATE_SUCCESS,
  SUBCONTRACT_COST_CREATE_FAILURE,
  SUBCONTRACT_COST_CREATE_RESET,
  SUBCONTRACT_COST_EDIT_REQUEST,
  SUBCONTRACT_COST_EDIT_SUCCESS,
  SUBCONTRACT_COST_EDIT_FAILURE,
  SUBCONTRACT_COST_EDIT_RESET,
  SUBCONTRACT_COST_EXPORT_REQUEST,
  SUBCONTRACT_COST_EXPORT_SUCCESS,
  SUBCONTRACT_COST_EXPORT_FAILURE,
  SUBCONTRACT_COST_EXPORT_RESET,
} from './../../constants'

export function createSubcontractCost(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/subcontract-cost-masters`,
      method: 'POST',
      types: [
        SUBCONTRACT_COST_CREATE_REQUEST,
        SUBCONTRACT_COST_CREATE_SUCCESS,
        SUBCONTRACT_COST_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getSubcontractCost(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/subcontract-cost-masters`,
      method: 'GET',
      types: [
        SUBCONTRACT_COST_GET_REQUEST,
        SUBCONTRACT_COST_GET_SUCCESS,
        SUBCONTRACT_COST_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editSubcontractCost(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/subcontract-cost-masters/${id}`,
      method: 'PUT',
      types: [
        SUBCONTRACT_COST_EDIT_REQUEST,
        SUBCONTRACT_COST_EDIT_SUCCESS,
        SUBCONTRACT_COST_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function exportSubcontractCost(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/subcontract-cost-masters/exports`,
      method: 'GET',
      types: [
        SUBCONTRACT_COST_EXPORT_REQUEST,
        SUBCONTRACT_COST_EXPORT_SUCCESS,
        SUBCONTRACT_COST_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetGetSubcontractCost() {
  return {
    type: SUBCONTRACT_COST_GET_RESET,
  }
}
export function resetCreateSubcontractCost() {
  return {
    type: SUBCONTRACT_COST_CREATE_RESET,
  }
}
export function resetEditSubcontractCost() {
  return {
    type: SUBCONTRACT_COST_EDIT_RESET,
  }
}
export function resetExportSubcontractCost() {
  return {
    type: SUBCONTRACT_COST_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/subcontract-cost/subcontract-cost-action.js